import { httpV2 } from '../http';
const base = '/property-task-defaults';
const PropertyTaskDefaultsService = {
  list: () => httpV2.get(base),
  preview: payload => httpV2.post(`${base}/preview`,payload),
  apply: id => httpV2.post(`${base}/batches/${id}/apply`),
  batch: id => httpV2.get(`${base}/batches/${id}`),
  history: params => httpV2.get(`${base}/history`,{params}),
  resolve: payload => httpV2.post(`${base}/resolve`,payload),
  taskHistory: id => httpV2.get(`${base}/tasks/${id}/history`),
};

export default PropertyTaskDefaultsService;
